export const modifierList = [
  'full',
  'full-in-grid',
  'secondary',
  'secondary-light',
  'transparent',
  'dark',
  'light',
  'white',
  'fixed-bottom',
  'sky-it',
];
